module.exports = __webpack_public_path__ + "static/media/fr-FR.f50d8f27.md";